import { render, staticRenderFns } from "./AddOrUpdateTrain.vue?vue&type=template&id=776a6ab5&scoped=true&"
import script from "./AddOrUpdateTrain.vue?vue&type=script&lang=ts&"
export * from "./AddOrUpdateTrain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776a6ab5",
  null
  
)

export default component.exports